require('/ui/components/entitypicker/tabs/tabs.module.scss.module.css');

export const uepTypeTab = "_uep-type-tab_u2u1v_1";
export const uepTypeTabSelected = "_uep-type-tab-selected_u2u1v_1";
export const uepTypeTabs = "_uep-type-tabs_u2u1v_1";
